const CURRENCY_SYMBOLS = {
  EUR: '€',
  USD: '$',
  GBP: '£',
  DZD: 'DA',
  TND: 'DT',
  MAD: 'DH',
};

export const SUPPORTED_CURRENCIES = Object.keys(CURRENCY_SYMBOLS);

export function currencySymbol(currency = 'EUR') {
  return CURRENCY_SYMBOLS[currency] || currency;
}

export function formatAmount(value, currency = 'EUR', decimals = 2) {
  const amount = Number(value || 0);
  return `${amount.toLocaleString('fr-FR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })} ${currencySymbol(currency)}`;
}

export function formatNumber(value, decimals = 2) {
  return Number(value || 0).toLocaleString('fr-FR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}
